import { Component, OnInit, HostListener } from '@angular/core';
import { album, closeAlbum, uploaded } from '../../shared/data/profile-pages/time-line';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { FeatherIconComponent } from '../../shared/components/common/feather-icon/feather-icon.component';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule, AbstractControl, ValidationErrors, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { NotificationService } from '../../services/notification.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user';
import { UiNotificationModel } from '../../models/ui-notification-model';
import { generateRandomId } from '../../helpers/utils';
import { RecaptchaModule } from 'ng-recaptcha';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map, catchError } from 'rxjs/operators';

declare global {
  interface Window {
    onRecaptchaLoad: () => void;
  }
}

interface Country {
  id: number;
  name: string;
  phone_code?: string;
  code?: string;
  codetelephonique?: string;
  chiffresmax?: string;
  flag?: string;
  // autres propriétés si nécessaire
}

interface NationalitiesResponse {
  data: Country[];
  // autres propriétés de la réponse si nécessaire
}

const RDC_PHONE_DIGITS = 9;
const RDC_PHONE_CODE = '+243';

@Component({
  selector: 'app-auth-register',
  standalone: true,
  imports: [
    FeatherIconComponent,
    NgbNavModule, 
    ReactiveFormsModule, 
    CommonModule, 
    RecaptchaModule,
    FormsModule
  ],
  templateUrl: './auth-register.component.html',
  styleUrl: './auth-register.component.scss'
})
export class AuthRegisterComponent implements OnInit {
  public  active = 1;
  public uploaded = uploaded;
  public album = album;
  public closeAlbum = closeAlbum;
  public isOpen :boolean = false;
  registerForm?: FormGroup;
  registerForm2?: FormGroup;
  isRegisterSubmited: boolean = false;
  isRegisterSubmited2: boolean = false;
  getRang: string;
  nom: string;
  public domains: any[] = [];
  public nationalities: Country[] = [];
  isLoading: boolean = false;
  public message: string[] = [];
  siteKey = '6LffYuIqAAAAANBczmsBmtbdS55Ox1tuZFdH-J3f';
  captchaResponse: string = '';
  isCountrySelectOpen = false;
  countrySearch = '';
  selectedCountry: any = null;
  selectedCountry2: any = null;
  filteredCountries: any[] = [];
  showPassword = false;
  showPasswordConfirmation = false;
  showPassword2 = false;
  showPasswordConfirmation2 = false;
  usernameSuggestions: string[] = [];
  usernameSuggestions2: string[] = []; // Pour le formulaire star

  constructor(
    public modalServices: NgbModal,
    private notificationService: NotificationService,
    private fb: FormBuilder, 
    private router: Router,
    private authService: AuthService,
  ) { }

  // Validateur personnalisé pour le username (pas d'espaces)
  usernameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Le username est optionnel
      }
      
      // Vérifier qu'il n'y a pas d'espaces
      if (/\s/.test(control.value.toString())) {
        return { hasSpaces: true };
      }
      
      return null;
    };
  }

  // Validateur asynchrone pour vérifier l'unicité du username (formulaire fan)
  usernameAsyncValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        this.usernameSuggestions = [];
        return of(null); // Pas de validation si vide
      }

      const username = control.value.toString().replace(/\s/g, ''); // Nettoyer les espaces

      // Si le username est vide après nettoyage, pas de validation
      if (!username) {
        this.usernameSuggestions = [];
        return of(null);
      }

      // Récupérer prenom et name du formulaire
      const prenom = this.registerForm?.get('prenom')?.value || '';
      const name = this.registerForm?.get('name')?.value || '';

      return of(username).pipe(
        debounceTime(500), // Attendre 500ms après la dernière frappe
        distinctUntilChanged(), // Éviter les requêtes redondantes
        switchMap((value: string) => {
          return this.authService.checkUsername(value, undefined, undefined, prenom, name).pipe(
            map((response: {available: boolean, suggestions?: string[]}) => {
              if (response.suggestions && response.suggestions.length > 0) {
                this.usernameSuggestions = response.suggestions;
              } else {
                this.usernameSuggestions = [];
              }
              return response.available ? null : { usernameTaken: true };
            }),
            catchError(() => {
              // En cas d'erreur, on considère que le username n'est pas disponible
              this.usernameSuggestions = [];
              return of({ usernameTaken: true });
            })
          );
        })
      );
    };
  }

  // Validateur asynchrone pour vérifier l'unicité du username (formulaire star)
  usernameAsyncValidator2(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        this.usernameSuggestions2 = [];
        return of(null); // Pas de validation si vide
      }

      const username = control.value.toString().replace(/\s/g, ''); // Nettoyer les espaces

      // Si le username est vide après nettoyage, pas de validation
      if (!username) {
        this.usernameSuggestions2 = [];
        return of(null);
      }

      // Récupérer prenom et name du formulaire
      const prenom = this.registerForm2?.get('prenom')?.value || '';
      const name = this.registerForm2?.get('name')?.value || '';

      return of(username).pipe(
        debounceTime(500), // Attendre 500ms après la dernière frappe
        distinctUntilChanged(), // Éviter les requêtes redondantes
        switchMap((value: string) => {
          return this.authService.checkUsername(value, undefined, undefined, prenom, name).pipe(
            map((response: {available: boolean, suggestions?: string[]}) => {
              if (response.suggestions && response.suggestions.length > 0) {
                this.usernameSuggestions2 = response.suggestions;
              } else {
                this.usernameSuggestions2 = [];
              }
              return response.available ? null : { usernameTaken: true };
            }),
            catchError(() => {
              // En cas d'erreur, on considère que le username n'est pas disponible
              this.usernameSuggestions2 = [];
              return of({ usernameTaken: true });
            })
          );
        })
      );
    };
  }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      prenom: ['', Validators.required],
      name: ['', Validators.required],
      nom: [{ value: '', disabled: true }],
      phone_code: ['+243', Validators.required],
      telephone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      username: ['', [this.usernameValidator()], [this.usernameAsyncValidator()]],
      domain_id: [''],
      rang: ['fan'],
      nationalite_id: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required, Validators.minLength(8)]],
      notification: ['email'],
      rgpdConsent: [false, Validators.requiredTrue],
      countrySearch: ['']
    }, { validator: this.passwordMatchValidator });

    this.registerForm2 = this.fb.group({
      prenom: ['', Validators.required],
      name: ['', Validators.required],
      scene_name: ['', Validators.required],
      nom: [{ value: '', disabled: true }],
      phone_code: ['+243', Validators.required],
      telephone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      username: ['', [this.usernameValidator()], [this.usernameAsyncValidator2()]],
      domain_id: ['0', Validators.required],
      rang: ['star'],
      nationalite_id: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required, Validators.minLength(8)]],
      notification: ['email'],
      rgpdConsent: [false, Validators.requiredTrue],
      countrySearch: ['']
    });
    
    this.registerForm.get('name')?.valueChanges.subscribe(value => {
      this.registerForm?.patchValue({ nom: value }, { emitEvent: false });
    });

    this.registerForm2.get('name')?.valueChanges.subscribe(value => {
      this.registerForm2?.patchValue({ nom: value }, { emitEvent: false });
    });
  
    this.displayDomains();
    this.displayNationnalities();

    const defaultRdc = this.createDefaultRdcCountry();
    this.selectedCountry = defaultRdc;
    this.selectedCountry2 = { ...defaultRdc };
    this.filteredCountries = this.nationalities;

    this.applyPhoneCountry(this.registerForm, defaultRdc);
    this.applyPhoneCountry(this.registerForm2, defaultRdc);
  }

  handleCaptchaResponse(response: string | null) {
    if (response) {
      this.captchaResponse = response;
      console.log('reCAPTCHA response:', response);
    }
  }
  

  get registerFormControls() {
    return this.registerForm?.controls;
  }

  get registerFormControls2() {
    return this.registerForm2?.controls;
  }

  displayDomains(){
    this.authService.getDomains().subscribe({
      next: (data) => {
        
        this.domains = data.data;
        console.log(this.domains);
      }
    });
  }

  displayNationnalities(){
    this.authService.getNationnalities().subscribe({
      next: (data: NationalitiesResponse) => {      
        this.nationalities = data.data.map((country: Country) => ({
          ...country,
          phone_code: country.codetelephonique || this.extractPhoneCode(country)
        }));
        
        // Trier par ordre alphabétique croissant du nom du pays
        this.nationalities.sort((a: Country, b: Country) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        
        this.filteredCountries = this.nationalities;

        const rdc = this.findRdcCountry(this.nationalities);
        if (rdc) {
          this.selectCountry(rdc);
          this.selectCountry2(rdc);
          this.registerForm?.patchValue({ nationalite_id: rdc.id });
          this.registerForm2?.patchValue({ nationalite_id: rdc.id });
        }
      }
    });
  }

  private createDefaultRdcCountry(): Country {
    return {
      id: 0,
      code: 'cd',
      codetelephonique: RDC_PHONE_CODE,
      phone_code: RDC_PHONE_CODE,
      chiffresmax: String(RDC_PHONE_DIGITS),
      name: 'République Démocratique du Congo',
      flag: 'flags/cd.svg',
    };
  }

  private findRdcCountry(countries: Country[]): Country | undefined {
    const byCode = countries.find(
      (country) => country.code?.toLowerCase().trim() === 'cd'
    );
    if (byCode) {
      return byCode;
    }

    return countries.find((country) => {
      const name = this.normalizeString((country.name || '').toLowerCase());
      return name.includes('democratique') && name.includes('congo');
    });
  }

  isRdcCountry(country: any): boolean {
    return (country?.code || '').toLowerCase().trim() === 'cd';
  }

  getPhoneMinLength(country: any): number {
    if (this.isRdcCountry(country)) {
      return RDC_PHONE_DIGITS;
    }
    const maxLength = this.getPhoneMaxLength(country);
    return Math.min(9, maxLength);
  }

  getPhoneValidationHint(country: any): string {
    if (this.isRdcCountry(country)) {
      return '9 chiffres (ex. 812345678), sans le 0 initial ni l\'indicatif +243';
    }
    const minLength = this.getPhoneMinLength(country);
    const maxLength = this.getPhoneMaxLength(country);
    if (minLength === maxLength) {
      return `${maxLength} chiffres`;
    }
    return `${minLength} à ${maxLength} chiffres`;
  }

  private buildPhoneValidators(country: any): ValidatorFn[] {
    const minLength = this.getPhoneMinLength(country);
    const maxLength = this.getPhoneMaxLength(country);
    return [
      Validators.required,
      Validators.minLength(minLength),
      Validators.maxLength(maxLength),
      Validators.pattern(/^[0-9]+$/),
    ];
  }

  private applyPhoneCountry(form: FormGroup | undefined, country: any): void {
    if (!form) {
      return;
    }

    const normalizedPhoneCode = this.normalizePhoneCode(
      country?.codetelephonique || country?.phone_code || RDC_PHONE_CODE
    );
    form.patchValue({ phone_code: normalizedPhoneCode }, { emitEvent: false });

    const maxLength = this.getPhoneMaxLength(country);
    form.get('telephone')?.setValidators(this.buildPhoneValidators(country));
    const currentPhone = form.get('telephone')?.value || '';
    form.get('telephone')?.setValue(this.normalizePhoneLocalPart(currentPhone, maxLength, country), {
      emitEvent: false,
    });
    form.get('telephone')?.updateValueAndValidity();
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('password_confirmation')?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  }

  selectSuggestion(suggestion: string, formType: 'fan' | 'star') {
    const cleaned = (suggestion || '').toString().replace(/\s/g, '');
    if (!cleaned) return;

    if (formType === 'fan' && this.registerForm) {
      this.registerForm.get('username')?.setValue(cleaned);
      this.usernameSuggestions = [];
      this.registerForm.get('username')?.markAsTouched();
      this.registerForm.get('username')?.updateValueAndValidity();
    }

    if (formType === 'star' && this.registerForm2) {
      this.registerForm2.get('username')?.setValue(cleaned);
      this.usernameSuggestions2 = [];
      this.registerForm2.get('username')?.markAsTouched();
      this.registerForm2.get('username')?.updateValueAndValidity();
    }
  }
  

  handleSubmitRegister(event: any) {
    event.preventDefault();
    
    if (!this.captchaResponse) {
      const notification: UiNotificationModel = {
        _id: generateRandomId(),
        title: "Erreur",
        message: "Veuillez compléter le reCAPTCHA",
        status: "danger",
        timeout: 2000
      };
      this.notificationService.emit(notification);
      return;
    }

    this.isRegisterSubmited = true;
  
    if (this.registerForm?.invalid) {
      return;
    }

    this.isLoading = true;

    if (this.registerForm) {
      this.registerForm.get('nom')?.enable();
      const formValue = this.registerForm.value;
      const phoneMax = this.getPhoneMaxLength(this.selectedCountry);
      const cleanPhone = this.normalizePhoneLocalPart(formValue.telephone || '', phoneMax, this.selectedCountry);
      const normalizedPhoneCode = this.normalizePhoneCode(
        formValue.phone_code || this.selectedCountry?.codetelephonique || this.selectedCountry?.phone_code
      );
      const cleanUsername = (formValue.username || '').replace(/\s/g, '');
      const user: User = {
        ...formValue,
        username: cleanUsername || null,
        phone_code: normalizedPhoneCode,
        telephone: `${normalizedPhoneCode}${cleanPhone}`
      };

      this.authService.register(user).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.notificationService.create('success'); 
          this.modalServices.dismissAll();           
          this.router.navigate(["/sendmail-info"]);               
        },
        error: (err: any) => {
          console.error("Erreur de l'API", err);
          this.isLoading = false;
          if (err.error && err.error.errors) {
            this.message = Object.values(err.error.errors).flat() as string[];
          } else {
            this.message = ['Une erreur inconnue est survenue.'];
          }
        }
      });

      this.registerForm.get('nom')?.disable();
    }
  }

  handleSubmitRegister2(event: any) {
    event.preventDefault();
    
    if (!this.captchaResponse) {
      const notification: UiNotificationModel = {
        _id: generateRandomId(),
        title: "Erreur",
        message: "Veuillez compléter le reCAPTCHA",
        status: "danger",
        timeout: 2000
      };
      this.notificationService.emit(notification);
      return;
    }

    this.isRegisterSubmited2 = true;
  
    if (this.registerForm2?.invalid) {
      return;
    }

    this.isLoading = true;

    if (this.registerForm2) {
      this.registerForm2.get('nom')?.enable();
      const formValue = this.registerForm2.value;
      const phoneMax = this.getPhoneMaxLength(this.selectedCountry2);
      const cleanPhone = this.normalizePhoneLocalPart(formValue.telephone || '', phoneMax, this.selectedCountry2);
      const normalizedPhoneCode = this.normalizePhoneCode(
        formValue.phone_code || this.selectedCountry2?.codetelephonique || this.selectedCountry2?.phone_code
      );
      const cleanUsername = (formValue.username || '').replace(/\s/g, '');
      const user: User = {
        ...formValue,
        username: cleanUsername || null,
        phone_code: normalizedPhoneCode,
        telephone: `${normalizedPhoneCode}${cleanPhone}`
      };

      this.authService.register(user).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.notificationService.create('success'); 
          this.modalServices.dismissAll();           
          this.router.navigate(["/sendmail-info"]);  
        },
        error: (err: any) => {
          console.error("Erreur de l'API", err);
          this.isLoading = false;
          if (err.error && err.error.errors) {
            this.message = Object.values(err.error.errors).flat() as string[];
          } else {
            this.message = ['Une erreur inconnue est survenue.'];
          }
        }
      });

      this.registerForm2.get('nom')?.disable();
    }
  }

  extractPhoneCode(country: Country): string {
    if (country.phone_code) {
      return country.phone_code.startsWith('+') ? country.phone_code : `+${country.phone_code}`;
    }
    const match = country.name.match(/\(([^)]+)\)/);
    if (match) {
      const code = match[1].trim();
      return code.startsWith('+') ? code : `+${code}`;
    }
    return '';
  }

  emit(): void {
    const notification: UiNotificationModel = {
      _id: generateRandomId(),
      title: "Test",
      message: "This is a test notification",
      status: "danger",
      timeout: 2000
    };
    this.notificationService.emit(notification);
  }

  onPhoneCodeChange(event: any) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];
    const fullText = selectedOption.getAttribute('data-full');
    const code = fullText.match(/\(([^)]+)\)/)[1];
    selectedOption.textContent = code;
  }

  toggleCountrySelect() {
    this.isCountrySelectOpen = !this.isCountrySelectOpen;
  }

  filterCountries() {
    const searchTerm = this.registerForm?.get('countrySearch')?.value?.toLowerCase() || '';
    if (!searchTerm) {
      this.filteredCountries = this.nationalities;
      return;
    }
    
    const normalizedSearch = this.normalizeString(searchTerm);
    this.filteredCountries = this.nationalities.filter(country => 
      this.normalizeString(country.name.toLowerCase()).includes(normalizedSearch) ||
      (country.codetelephonique && country.codetelephonique.includes(searchTerm))
    );

    this.filteredCountries.sort((a: Country, b: Country) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
  }

  private normalizeString(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  selectCountry(country: any) {
    this.selectedCountry = country;
    this.applyPhoneCountry(this.registerForm, country);
    this.isCountrySelectOpen = false;
  }

  selectCountry2(country: any) {
    this.selectedCountry2 = country;
    this.applyPhoneCountry(this.registerForm2, country);
    this.isCountrySelectOpen = false;
  }

  getFlagClass(): string {
    if (!this.selectedCountry?.code) {
      return 'flag-icon-cd';
    }
    return `flag-icon-${this.selectedCountry.code.toLowerCase()}`;
  }

  getFlagClass2(): string {
    if (!this.selectedCountry2?.code) {
      return 'flag-icon-cd';
    }
    return `flag-icon-${this.selectedCountry2.code.toLowerCase()}`;
  }

  getPhoneMaxLength(country: any): number {
    if (this.isRdcCountry(country)) {
      return RDC_PHONE_DIGITS;
    }
    const maxLengthFromCountry = Number.parseInt((country?.chiffresmax ?? '').toString(), 10);
    if (Number.isNaN(maxLengthFromCountry) || maxLengthFromCountry <= 0) {
      return 15;
    }
    return Math.min(maxLengthFromCountry, 15);
  }

  private normalizePhoneLocalPart(phone: string, maxLength: number, country?: any): string {
    let digits = (phone || '').replace(/\D/g, '');

    if (country && this.isRdcCountry(country) && digits.startsWith('0')) {
      digits = digits.slice(1);
    }

    return digits.slice(0, maxLength);
  }

  private normalizePhoneCode(phoneCode: string): string {
    const digits = (phoneCode || '').toString().replace(/\D/g, '');
    return digits ? `+${digits}` : '';
  }

  onPhoneInput(event: any, formGroup: FormGroup | undefined) {
    const inputValue = event.target.value || '';
    const normalizedValue = this.normalizePhoneLocalPart(
      inputValue,
      this.getPhoneMaxLength(this.selectedCountry),
      this.selectedCountry
    );

    formGroup?.get('telephone')?.setValue(normalizedValue, { emitEvent: false });
  }

  onPhoneInput2(event: any) {
    const inputValue = event.target.value || '';
    const normalizedValue = this.normalizePhoneLocalPart(
      inputValue,
      this.getPhoneMaxLength(this.selectedCountry2),
      this.selectedCountry2
    );

    this.registerForm2?.get('telephone')?.setValue(normalizedValue, { emitEvent: false });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.country-select-wrapper')) {
      this.isCountrySelectOpen = false;
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordConfirmationVisibility() {
    this.showPasswordConfirmation = !this.showPasswordConfirmation;
  }

  togglePasswordVisibility2() {
    this.showPassword2 = !this.showPassword2;
  }

  togglePasswordConfirmationVisibility2() {
    this.showPasswordConfirmation2 = !this.showPasswordConfirmation2;
  }
}
